import { render, staticRenderFns } from "./Ledger.vue?vue&type=template&id=2e4b7e46&scoped=true"
import script from "./Ledger.vue?vue&type=script&lang=ts"
export * from "./Ledger.vue?vue&type=script&lang=ts"
import style0 from "./Ledger.vue?vue&type=style&index=0&id=2e4b7e46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4b7e46",
  null
  
)

export default component.exports